import { FiltroModel } from "./FiltroModel";

export class DadosConsultaModel{
    idReport: number;        
    reportFilters: FiltroModel[];
    pageNumber:number;
    pageSize:number;
    reportName: string;
    orderByField: string;        
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/DadosConsultaModel.ts